<div class="_flex _gap-2"
    [ngClass]="banner ? '_flex-row _items-center' : '_flex-col'">
    <div *ngIf="headingText" class="_flex _items-center">
        <i class="fa-regular fa-face-thinking _mr-1"></i>
        <div class="_text-h5 md:_text-h4 _font-heading">{{ headingText }}</div>
    </div>
    <div *ngIf="bodyText" class="_text-md">{{ bodyText }}</div>
    <ng-container *ngIf="!useCustomContentCta">
        <button *ngIf="!banner" class="_button-primary _mt-2" (click)="openContactForm()">{{ ctaText }}</button>
        <button *ngIf="banner" class="_text-md _underline" (click)="openContactForm()">{{ ctaText }}</button>  
    </ng-container>
    <div *ngIf="useCustomContentCta" (click)="openContactForm()">
        <ng-content></ng-content>
    </div>
</div>
